const CameraMaxZoomLevels = {
	HELLO_MAX: 5,
	HUDDLE_MAX: 20,
};

export default CameraMaxZoomLevels;
